// Copyright (c) Zammo Inc.

import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

import Button from '../buttons/Button';

const Container = styled.div`
  font-size: 1rem;

  > div {
    margin-bottom: 1rem;
    line-height: 1.5;
  }
`;

const style = {
  content: {
    bottom: 'auto',
    height: 'auto', // set height
    left: '50%',
    padding: '2rem',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%, -50%)', // adjust top "up" based on height
    width: '40%',
    maxWidth: '40rem',
  },
};

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
}
const TtsAvatarOnlySimulatorWelcomeModal = ({ isOpen, onConfirm }: Props) => {
  return (
    <Modal isOpen={isOpen} style={style}>
      <Container>
        <div>The TTS Avatar uses the content saved in your agent or conversation.</div>
        <div>
          The delay between responses and speech to text recognition may vary slightly between channels when published.
        </div>
      </Container>
      <div style={{ textAlign: 'center', marginTop: '1rem' }}>
        <Button type="button" onClick={onConfirm}>
          OK
        </Button>
      </div>
    </Modal>
  );
};

export default TtsAvatarOnlySimulatorWelcomeModal;
